import React, { useState } from 'react'
import { Box, LinearProgress, Theme, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import cx from 'classnames'
import { InlineEdit } from '../../../../../../../../components/InlineEdit/InlineEdit'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      display: 'none',
    },
  })
)

interface Props {
  title: string
  value: number
  valueMax: number
  color: any
  bgColor: any
  editable?: boolean
  onEdit?: (value: string) => void
}

export const ColoredBar: React.FC<Props> = ({
  title,
  value,
  valueMax,
  color,
  bgColor,
  editable,
  onEdit,
}) => {
  const [editMode, setEditMode] = useState(false)
  const classes = useStyles()
  return (
    <div>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          className={cx(editMode && classes.hidden)}
          variant="body2"
          color="text.secondary"
          onClick={() => editable && setEditMode(true)}
        >
          <strong>{title}</strong> {value} / {valueMax}
        </Typography>
        {editable && editMode && (
          <InlineEdit
            defaultValue={String(value)}
            onEdit={v => {
              onEdit && onEdit(v)
              setEditMode(false)
            }}
            onCancel={() => {
              setEditMode(false)
            }}
          />
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%' }}>
          <LinearProgress
            variant="determinate"
            value={Math.min(value / valueMax, 1) * 100}
            classes={{
              colorPrimary: bgColor,
              barColorPrimary: color,
            }}
          />
        </Box>
      </Box>
    </div>
  )
}
